import { ShieldAlert } from 'lucide-react'
import { StatusScreen } from '@/components/common/StatusScreen'
import { defineMessages, useMessages } from '@/i18n'

const messages = defineMessages({
  ru: {
    title: 'Нет доступа',
    hint: 'Этот раздел доступен только администраторам.',
    back: 'Вернуться ко входу',
  },
  en: {
    title: 'Access denied',
    hint: 'This area is for administrators only.',
    back: 'Back to sign in',
  },
})

export const AccessDenied = () => {
  const m = useMessages(messages)
  return (
    <StatusScreen
      icon={ShieldAlert}
      title={m.title}
      hint={m.hint}
      actionLabel={m.back}
      actionTo="/auth"
    />
  )
}
